import React, { useState } from 'react'
import keys from 'lodash/keys'
import { TagsSettings } from 'src/types/Main'
import ArrowDownIco from 'src/static/icons/ico_arrow_down.svg'
import GridOptions from '../utils/ValuesRender/Tags/Grid/GridOptions'
import ListOptions from '../utils/ValuesRender/Tags/List/ListOptions'
import ColorOptions from '../utils/ValuesRender/Tags/Color/ColorOptions'
import useI18n from 'src/hooks/useI18n'
import { translateString } from '../utils/translateString'
import { formatString } from '../utils/formatString'

interface Props {
  tag: TagsSettings;
  startOpen: boolean;
  resetMode: string;
  filteredTags: Record<string, string[]>;
  setFilteredTags(tags: Record<string, string[]>): void;
  filterOnClick: boolean;
  clearTags(tags: Record<string, string[]>): void;
}

const Tag = (props: Props) => {
  const {
    tag,
    startOpen,
    resetMode,
    filteredTags,
    filterOnClick,
    setFilteredTags,
    clearTags
  } = props

  const BASE_CLASS_CSS = 'filter-vertical-tags'
  const normalizedTagType = formatString(tag.type)
  const translation = useI18n()

  const [open, setOpen] = useState(() => {
    return startOpen || keys(filteredTags).some((tagId) => {
      return tagId === tag.type || decodeURIComponent(tagId) === tag.type
    })
  })

  const handleOpen = () => {
    const eventName = open ? 'vnda:filter-component-item-close' : 'vnda:filter-component-item-open'
    const customOpenEvent = new CustomEvent(eventName, {
      detail: {
        itemClass: BASE_CLASS_CSS,
        itemName: translateString(tag.title)
      }
    })
    window.dispatchEvent(customOpenEvent)
    setOpen(!open)
  }

  const resetFilter = (event: React.MouseEvent) => {
    event.stopPropagation()
    const newFilteredTags = filteredTags
    delete newFilteredTags[tag.type]
    clearTags(newFilteredTags)
  }

  return (
    <div className={`${BASE_CLASS_CSS}-container filter-tags-${normalizedTagType}-container filter-tags-container filter-item-container ${open ? 'filter-item-open' : ''}`}>
      <div
        className={`${BASE_CLASS_CSS}-header filter-item-header`}
        onClick={handleOpen}
      >
        <div className={`${BASE_CLASS_CSS}-header-container filter-item-header-container`}>
          <span className="filter-item-title">
            {translateString(tag.title)}
          </span>
          <div className="arrow-container">
            <img className="arrow-image" src={ArrowDownIco} />
          </div>
        </div>
        {resetMode === 'each' && (
          <span
            className={`${BASE_CLASS_CSS}-header-clear filter-item-clear`}
            onClick={resetFilter}
          >
            {translation.filter.clean}
          </span>
        )}
      </div>
      <div
        className={`${BASE_CLASS_CSS}-content filter-item-content ${open ? '-open' : ''}`}>
        {tag.style === 'grid' && (
          <GridOptions
            tagType={tag.type}
            filters={tag.options}
            filteredTags={filteredTags}
            setFilteredTags={setFilteredTags}
            filterOnClick={filterOnClick}
          />
        )}
        {tag.style === 'list' && (
          <ListOptions
            tagType={tag.type}
            filters={tag.options}
            filteredTags={filteredTags}
            setFilteredTags={setFilteredTags}
            filterOnClick={filterOnClick}
          />
        )}
        {tag.style === 'colors' && (
          <ColorOptions
            tagType={tag.type}
            colorsProps={
              tag?.colorsProps || { showTitle: true, showColor: true }
            }
            filters={tag.options}
            filteredTags={filteredTags}
            setFilteredTags={setFilteredTags}
            filterOnClick={filterOnClick}
          />
        )}
      </div>
    </div>
  )
}

export default Tag
